import React from 'react';
import Link from 'next/link';
import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Paper from '@material-ui/core/Paper';
import RateReviewIcon from '@material-ui/icons/RateReview';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import useStylesBase from '../../../assets/jss/card-styles';

const useStyles = () => makeStyles((theme) => ({
  card: {
    backgroundColor: theme.palette.error.light,
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
    position: 'relative',
    justifyContent: 'center',
  },
}));

export const QACard = (props) => {
  const classes = useStyles(props)();
  const classesBase = useStylesBase(props)();

  const totalEvents = props.count;

  return (
    <Card className={classes.card}>
      <div className={classesBase.cardHeader}>
        <Paper elevation={6} square className={classesBase.headerPaper}>
          <RateReviewIcon />
        </Paper>
      </div>
      <CardContent className={classesBase.cardContent}>
        <Typography align='center' className={classesBase.theCount} component='p' variant='h3'>
          {totalEvents}
        </Typography>
        <Typography align='center' className={classesBase.TheMessage}>
          {props.message}
        </Typography>
        <Link href='/entries?status=QA Issue'>
          <Button variant='outlined' className={classesBase.cardButton}>
            {'VIEW QA ISSUES'}
          </Button>
        </Link>
      </CardContent>
    </Card>
  );
};
